import { IconX } from "@tabler/icons-react";
import React from "react";
import ArrowEndLight from "@/assets/icons/arrowEndLight.svg?react";
import ArrowSeparatorLight from "@/assets/icons/arrowSeparatorLight.svg?react";

interface CategoryGroupItemProps {
  parentParts: string[];
  childPaths: string[];
  onRemove: () => void;
}

export const CategoryGroupItem: React.FC<CategoryGroupItemProps> = ({
  parentParts,
  childPaths,
  onRemove,
}) => {
  return (
    <div data-no-bubble className="text-start leading-6 align-middle w-fit">
      <div className="inline w-fit items-center text-[12px]/[14px] py-1 bg-[#f3f3f3] px-[5px] rounded-tl-[5px] rounded-bl-[5px] hover:cursor-default">
        {parentParts.map((part, i) => (
          <React.Fragment key={`p-${i}-${part}`}>
            {i > 0 && <ArrowSeparatorLight className="inline mt-[-1px]" color="#f3f3f3" />}
            <span className="inline whitespace-pre-line">
              <span className="text-[#474747] align-middle font-normal">{part}</span>
            </span>
          </React.Fragment>
        ))}
        <ArrowSeparatorLight className="inline mt-[-1px]" color="#f3f3f3" />
        {childPaths.map((path, i) => {
          const last = path.split("/").findLast(Boolean) ?? "";
          return (
            <React.Fragment key={`c-${i}-${path}`}>
              {i > 0 && <span className="text-[#B6B6B6] w-[5px] text-center font-normal px-1">/</span>}
              <span className="align-middle ml-1.5 text-[#6888e1] font-semibold">{last}</span>
            </React.Fragment>
          );
        })}
      </div>
      <ArrowEndLight className="inline ml-[-1px] mt-[-1px]" color="#f3f3f3" />
      <button
        onClick={onRemove}
        aria-label="Remove"
        className="h-[22px] w-6 inline hover:opacity-70 hover:cursor-pointer"
      >
        <IconX size={16} className="text-[#C0C0C0] inline" />
      </button>
    </div>
  );
};
